import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import ScrollToTop from "./public/components/ScrollToTop";

// Public (eager)
import Home from "./public/pages/Home";
import PublicLayout from "./public/PublicLayout";

// Admin auth (eager)
import ProtectedAdminRoute from "./admin/ProtectedAdminRoute";

// Public lazy pages
const About = lazy(() => import("./public/pages/About"));
const Academics = lazy(() => import("./public/pages/Academics"));
const Gallery = lazy(() => import("./public/pages/Gallery"));
const ContactUs = lazy(() => import("./public/pages/ContactUs"));
const Admission = lazy(() => import("./public/pages/AdmissionPage"));

// Admin lazy (separate chunk)
const AdminLogin = lazy(() => import("./admin/AdminLogin"));
const AdminLayout = lazy(() => import("./admin/AdminLayout"));
const AdminDashboard = lazy(() => import("./admin/AdminDashboard"));
const ManageNotices = lazy(() => import("./admin/ManageNotices"));
const ManageAdmissions = lazy(() => import("./admin/ManageAdmissions"));

const PageLoader = () => (
  <div style={{ padding: "60px", textAlign: "center" }}>Loading page…</div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* PUBLIC */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/academics" element={<Academics />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/admission" element={<Admission />} />
          </Route>

          {/* ADMIN */}
          <Route path="/admin/login" element={<AdminLogin />} />

          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute>
                <AdminLayout />
              </ProtectedAdminRoute>
            }
          >
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="notices" element={<ManageNotices />} />
            <Route path="admissions" element={<ManageAdmissions />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
